// import { DataSource } from 'ng2-smart-table/lib/lib/data-source/data-source';
import { Observable } from 'rxjs';
import { has, isNil, isObject, isString, find, isEmpty,  } from 'lodash';

import { DataSource, ServerDataSource } from 'angular2-smart-table';
// import { ViewCell } from 'ng2-smart-table';
import { Model } from './common/.base.model';
import { Author } from './author';
import { Department } from './department';
import { JobPosting } from './job-posting';
import { Person } from './person';
import { EntityConfigTemplate } from './common/entity-config.interface';

export interface Application extends Model {
  posting: JobPosting;
  person: Person;
  cv: any;
  coverLetter: any;
  applicationStatus: string;
  submittedAt: Date;
}

export const ApplicationConfig: EntityConfigTemplate = {
  meta: { entityName: 'application', entityPluralName: 'applications', titleField: 'id', view: false, attachedToField: 'posting' },
  posting: { view: false, isForeignKey: true, entityName: 'job-posting', title: 'Job Posting', type:'relation', valuePrep: (_cell_, row) => `${row?.posting?.title ?? ''}` },
  person: { isForeignKey: true, type: 'relation', title: 'Person', valuePrep: (_cell_, row) => `${row?.person?.firstName ?? ''} ${row?.person?.lastName ?? ''}` },
  'person.email': { title: 'Email', valuePrep: (_:any, row) => row?.person?.email ?? '' },
  'person.phone': { title: 'Phone',  valuePrep: (_:any, row) => row?.person?.phone ?? '', },
  'person.address': { title: 'Address',  valuePrep: (_:any, row) => row?.person?.address ?? '', },
  cv: { title: 'CV', type: 'file' },
  coverLetter: { title: 'Cover Letter', type: 'file' },
  applicationStatus: { title: 'Application Status' },
  submittedAt: { title: 'Submitted At', type: 'date' },
};

export abstract class ApplicationData {
  abstract get gridDataSource(): ServerDataSource;
  abstract list(pageNumber: number, pageSize: number): Observable<Application[]>;
  abstract get(id: string): Observable<Application>;
  abstract update(Application: Application): Observable<Application>;
  abstract create(Application: Application): Observable<Application>;
  abstract delete(id: string): Observable<boolean>;
  
}




